<template>
  <div>
    <v-row>
      <v-col>
        <p v-if="!onlyAcc" class="btn-wrp"><v-btn @click="()=>{this.$router.go()}">Go Back</v-btn></p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <v-select
          label="Year"
          :items="years"
          item-text="year"
          v-model="year"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
          label="Make"
          :disabled="!year"
          :items="makes"
          item-text="makeDescription"
          v-model="make"
          return-object
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
          label="Model"
          :disabled="!make"
          :items="models"
          item-text="modelDescription"
          v-model="model"
          return-object
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<style>
  .btn-wrp {
    padding-top: 15px;
    padding-bottom: 15px;
  }
</style>

<script>
  import Years from '../services/years'
  import Makes from '../services/makes'
  import Models from '../services/models'

  export default {
    name: 'Vehicle',
    props: {
      onlyAcc: Boolean
    },
    data () {
      return {
        years: [],
        makes: [],
        models: [],
        show: false
      }
    },
    computed: {
      year: {
        get () {
          return this.$store.state.year
        },
        set (year) {
          this.$store.commit('setYear', year)
        }
      },
      make: {
        get () {
          return this.$store.state.make
        },
        set (make) {
          this.$store.commit('setMake', make)
        }
      },
      model: {
        get () {
          return this.$store.state.model
        },
        set (model) {
          this.$store.commit('setModel', model)
        }
      }
    },
    watch: {
      year: function (year) {
        this.make = ''
        this.getMakes(year)
      },
      make: function (make) {
        this.model = ''
        if (make) {
          this.getModels(this.year, make)
        }
      }
    },
    mounted () {
      this.getYears()
    },
    methods: {
      async getYears () {
        this.years = await Years.get()
      },
      async getMakes (year) {
        this.makes = await Makes.get(year)
      },
      async getModels (year, make) {
        this.models = await Models.get(year, make.makeId)
      }
    }
  }
</script>

